import React from "react";
import { useRouteError, Link } from "react-router-dom";
import { Button, Result, Space, Typography } from "antd";
import { ReloadOutlined, HomeOutlined } from "@ant-design/icons";
import "./Fallback.less";

const { Text, Paragraph } = Typography;

const Fallback = () => {
  const error = useRouteError();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className='fallback-container'>
      <Result
        status='error'
        title='Oops! Something went wrong'
        subTitle='We apologize for the inconvenience'
        extra={
          <Space direction='vertical' align='center' size='middle'>
            <Button
              type='primary'
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
            >
              Refresh Page
            </Button>
            <Button type='default' icon={<HomeOutlined />}>
              <Link to='/'>Back to Home</Link>
            </Button>
          </Space>
        }
      />
    </div>
  );
};

export default Fallback;
